import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaMoneyBill, FaUpload, FaPen, FaPlus, FaThumbsUp, FaSearch, FaFileInvoice, FaFileAlt, FaThumbsDown } from 'react-icons/fa';
import { ImCancelCircle } from 'react-icons/im';
import { IoLogoUsd } from 'react-icons/io';
import NavItem from '../../components/NavItem';
import IconButton from '../../components/IconButton';
import Alert from '../../components/Alert';
import api from '../../services/api';
import DataTable from 'react-data-table-component';
import TabelaLoading from '../../components/TabelaLoading';
import TabelaVazia from '../../components/TabelaVazia';
import moment from 'moment';
import ReactSelect from '../../components/ReactSelect';
import Data from '../../components/Data';
import UploadButton from '../../components/UploadButton';
import FormButton from '../../components/FormButton';
import { useLocation } from 'react-router-dom';
import { moeda } from '../../util/util';

export default function PainelVenda() {
    const token = localStorage.getItem('token');
    const empresa = localStorage.getItem("empresa");
    const perfil = localStorage.getItem("perfil");
    const [filtro, setFiltro] = useState({
        modulo: 1,
        empresa: empresa
    }); //1 - venda
    const [dados, setDados] = useState({});
    const [vendas, setVendas] = useState([]);
    const [tableSelect, setTableSelect] = useState([]);
    const [tableActions, setTableActions] = useState([]);
    const params = new URLSearchParams(window.location.search);
    const idVenda = params.get('idVenda');
    let { state } = useLocation();
    const grupoTitulo = state ? (state.grupoTitulo ? state.grupoTitulo : null) : null;

    const buscar = () => {
        setFiltro(prev => ({ ...prev, buscando: true }));
        api({
            method: 'get',
            action: '/venda',
            token: token,
            params: {
                ...filtro,
                ...{ id: idVenda },
                ...{ grupoTitulo: grupoTitulo }
            }
        })
            .then(response => {
                setVendas(response.data.data);
                setFiltro(prev => ({ ...prev, buscando: false }));
            }).catch(err => {
                //console.log(err)
            })
    };

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    useEffect(() => { //onload
        buscar();

    },
        // eslint-disable-next-line
        [filtro.tipo, filtro.evento]);

    useEffect(() => { //onload
        var arrayids = tableSelect.selectedRows ? tableSelect.selectedRows.map((row) => {
            return row.id;
        }) : [];

        if (tableSelect.selectedCount > 0) {
            setTableActions([
                (['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro'].includes(perfil)) ?
                    <IconButton
                        small={true}
                        icon={<FaThumbsUp size={20} />}
                        onClick={() => {
                            Alert({
                                icon: "question",
                                confirmButton: <><FaThumbsUp size={20} /> Aprovar</>,
                                denyButton: "Sair",
                                title: "Aprovar",
                                callBack: (result) => {
                                    //{isConfirmed: false, isDenied: true, isDismissed: false, value: false}
                                    if (result.isConfirmed) {
                                        api({
                                            method: 'put',
                                            action: '/venda/aprovacao',
                                            token: token,
                                            data: {
                                                vendas: arrayids,
                                                aprovacao: "aprovado",
                                            }
                                        })
                                            .then(function (response) {
                                                buscar();
                                                //alert("Evento cancelado com sucesso!");
                                            })
                                            .catch(function (error) {
                                                //alert(error)
                                            });
                                    }
                                }
                            });
                        }
                        }
                        color="primary"> Aprovar</IconButton > : null,
                (['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro'].includes(perfil)) ?
                    <IconButton
                        small={true}
                        icon={<FaThumbsDown size={20} />}
                        onClick={() => {
                            Alert({
                                icon: "question",
                                confirmButton: "Sair",
                                denyButton: <><FaThumbsDown size={20} /> Reprovar</>,
                                title: "Reprovar",
                                html:
                                    <input type="text"
                                        className="form-control form-control-lg"
                                        id="motivoReprovado"
                                        placeholder="Motivo"
                                        value={dados.motivoReprovado}
                                        onChange={(e) => {
                                            dados.motivoReprovado = e.target.value;
                                            setDados({ ...dados });
                                        }}
                                    />,
                                callBack: (result) => {
                                    //{isConfirmed: false, isDenied: true, isDismissed: false, value: false}
                                    if (result.isDenied) {
                                        api({
                                            method: 'put',
                                            action: '/venda/aprovacao',
                                            token: token,
                                            data: {
                                                vendas: arrayids,
                                                aprovacao: "reprovado",
                                                motivoReprovado: dados.motivoReprovado,
                                            }
                                        })
                                            .then(function (response) {
                                                buscar();
                                            })
                                            .catch(function (error) {
                                            });
                                    }
                                }
                            });
                        }
                        }
                        color="warning" > Reprovar</IconButton > : null,
                tableSelect.selectedRows.length === 1 ? //apenas 1 selecionado
                    <IconButton
                        small={true}
                        icon={<ImCancelCircle size={20} />}
                        onClick={() => {
                            Alert({
                                icon: "error",
                                confirmButton: "Sair",
                                denyButton: <><FaThumbsUp size={20} /> Excluir</>,
                                title: "Excluir",
                                callBack: (result) => {
                                    //{isConfirmed: false, isDenied: true, isDismissed: false, value: false}
                                    if (result.isDenied) {
                                        api({
                                            method: 'delete',
                                            action: '/venda/' + tableSelect.selectedRows[0].id,
                                            token: token
                                        })
                                            .then(function (response) {
                                                buscar();
                                                //alert("Evento cancelado com sucesso!");
                                            })
                                            .catch(function (error) {
                                                //alert(error)
                                            });
                                    }
                                }
                            });
                        }
                        }
                        color="primary"> Excluir</IconButton > : null,
                tableSelect.selectedRows.length === 1 ? //apenas 1 selecionado
                    <UploadButton
                        small={true}
                        icon={<FaUpload size={20} />}
                        color="primary"
                        acaoApi={"vendaArquivo/" + tableSelect.selectedRows[0].id}
                        title="Pedido de Compra"
                        callBack={() => { buscar(); }}
                        dados={{
                            tipoArquivo: "pedidocompra",
                            modulo: "venda",
                            pasta: "pedidocompra"
                        }}
                    >Pedido de Compra</UploadButton> : null,

                tableSelect.selectedRows.length === 1 ? //apenas 1 selecionado
                    <UploadButton
                        small={true}
                        icon={<FaUpload size={20} />}
                        color="primary"
                        acaoApi={"vendaArquivo/" + tableSelect.selectedRows[0].id}
                        title="Nota Fiscal"
                        callBack={() => { buscar(); }}
                        dados={{
                            tipoArquivo: "notafiscal",
                            modulo: "venda",
                            pasta: "notafiscal"
                        }}
                    >Nota Fiscal</UploadButton> : null,
                tableSelect.selectedRows.length > 1 ? //apenas 1 selecionado
                    <IconButton
                        small={true}
                        title="Agrupar Pagamentos"
                        to={{
                            pathname: "/cadastroParcelaReceber",
                            state: {
                                vendas: arrayids,
                                acao: "agrupar"
                            }
                        }}
                        icon={<IoLogoUsd size={20} />}
                        color={"primary"} >Agrupar Pagamentos</IconButton> : null,
            ]);
        } else {
            setTableActions([]);
        }

    },
        // eslint-disable-next-line
        [tableSelect]);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid">
                <ul className="nav">
                    <NavItem to="/cadastroVenda" icon={<FaPlus size={20} />} color="primary">Nova Prestação de Serviço</NavItem>
                </ul>
                <div className="page-title">
                    <h3>Clientes</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <form className="form" onSubmit={(e) => { buscar(); e.preventDefault(); }}>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Evento</label>
                                                        <ReactSelect
                                                            value={{ value: filtro.evento, label: filtro.nomeEvento }}
                                                            onChange={(e) => {
                                                                setFiltro({ ...filtro, ...{ "evento": e.value, "nomeEvento": e.label } });
                                                            }}
                                                            loadOptions={(input) => {
                                                                return api({
                                                                    method: 'get',
                                                                    action: '/evento',
                                                                    token: token,
                                                                    params: {
                                                                        nome: input,
                                                                        situacao: ["ativo", "fechado"]
                                                                    }
                                                                })
                                                                    .then(response => {
                                                                        let options = response.data.data.map((registro) => {
                                                                            var label = registro.nome;
                                                                            if (registro.identificacao) {
                                                                                label = registro.identificacao + " - " + label;
                                                                            }
                                                                            if (registro.cliente) {
                                                                                label = label + ' - ' + registro.cliente.nome;
                                                                            }
                                                                            label = registro.codigo + " - " + label;
                                                                            return { value: registro.id, label: label }
                                                                        });
                                                                        return options;
                                                                    })
                                                                    .catch(function (error) {
                                                                        //console.log(error);
                                                                    });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-4">
                                                    <div className="form-floating form-group">
                                                        <input type="text" className="form-control form-control-lg" id="codigo" placeholder="Buscar pelo número do serviço"
                                                            onChange={e => setFiltro({ ...filtro, ...{ "codigo": e.target.value } })}
                                                        />
                                                        <label htmlFor="floatingInput">Número</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Cliente</label>
                                                        <ReactSelect
                                                            value={{ value: filtro.cliente, label: filtro.nomeCliente }}
                                                            onChange={e => setFiltro({ ...filtro, ...{ "cliente": e.value, "nomeCliente": e.label } })}
                                                            loadOptions={(input) => {
                                                                return api({
                                                                    method: 'get',
                                                                    action: '/participante',
                                                                    token: token,
                                                                    params: {
                                                                        nome: input,
                                                                        tipoCadastro: ["cliente", "empresa"],
                                                                        situacaoRegistro: "ativo",
                                                                    }
                                                                })
                                                                    .then(response => {
                                                                        let options = response.data.data.map((registro) => {
                                                                            var label = registro.codigo +
                                                                                ' - ' + registro.nome +
                                                                                (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                                                (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                                                (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                                                (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                                            return {
                                                                                value: registro.id,
                                                                                label: label
                                                                            };
                                                                        });
                                                                        return options;
                                                                    })
                                                                    .catch(function (error) {
                                                                        //console.log(error);
                                                                    });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <Data
                                                        label="Data"
                                                        value={filtro.data1}
                                                        onChange={date => setFiltro({ ...filtro, ...{ "data1": date } })}
                                                    />
                                                </div>
                                                <div className="col-sm-6">
                                                    <Data
                                                        label="até a Data"
                                                        value={filtro.data2}
                                                        onChange={date => setFiltro({ ...filtro, ...{ "data2": date } })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 d-flex justify-content-end">
                                                    <button type="submit" className="btn btn-primary me-1 mb-1">
                                                        <FaSearch size={20} /> Buscar</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section">
                    <div className="row mb-4">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body px-0 pb-0">
                                    <div className="table-responsive">
                                        <DataTable
                                            progressPending={filtro.buscando ?? false}
                                            persistTableHead
                                            progressComponent={<TabelaLoading />}
                                            noContextMenu="true"
                                            actions={tableActions}
                                            selectableRows="true"
                                            selectableRowsHighlight="true"
                                            onSelectedRowsChange={({ allSelected, selectedCount, selectedRows }) => {
                                                setTableSelect({ allSelected, selectedCount, selectedRows });
                                            }}
                                            noDataComponent={<TabelaVazia />}
                                            paginationComponentOptions={{ rowsPerPageText: 'Linhas', rangeSeparatorText: 'de', selectAllRowsItem: true, selectAllRowsItemText: 'Todos' }}
                                            pagination="true"
                                            className="table mb-0"
                                            columns={[
                                                {
                                                    name: '',
                                                    selector: 'codigo',
                                                    cell: row => <IconButton
                                                        small={true}
                                                        to={"/cadastroVenda/" + row.id}
                                                        icon={<FaPen size={20} />}
                                                        color="primary">Alterar</IconButton>,
                                                    width: "110px",
                                                },
                                                {
                                                    name: '',
                                                    selector: 'arquivopedidocompra',
                                                    cell: row => row.arquivopedidocompra ? <FormButton
                                                        method="get"
                                                        title="Pedido de compra"
                                                        action={process.env.REACT_APP_API_URL + "/vendaArquivo/" + row.id}
                                                        icon={<FaFileInvoice size={20} />}
                                                        color="primary"
                                                        data={{
                                                            token: localStorage.getItem('token'),
                                                            tipoArquivo: "pedidocompra"
                                                        }}
                                                    /> : null,
                                                    width: "60px",
                                                },
                                                {
                                                    name: '',
                                                    selector: 'arquivonotafiscal',
                                                    cell: row => row.arquivonotafiscal ? <FormButton
                                                        method="get"
                                                        title="Nota Fiscal"
                                                        action={process.env.REACT_APP_API_URL + "/vendaArquivo/" + row.id}
                                                        icon={<FaFileAlt size={20} />}
                                                        color="primary"
                                                        data={{
                                                            token: localStorage.getItem('token'),
                                                            tipoArquivo: "notafiscal"
                                                        }}
                                                    /> : null,
                                                    width: "60px",
                                                },
                                                {
                                                    name: 'Número',
                                                    selector: row => row.codigo ?? "",
                                                    sortable: true,
                                                    width: "100px",
                                                    right: true,
                                                    cell: (row) => {
                                                        return <div>
                                                            <div className="right">{row.codigo}</div>
                                                            {(row.aprovacao !== undefined && row.aprovacao === 'aprovado') ? <span className="badge bg-success">Aprovado</span> : null}
                                                            {(row.aprovacao !== undefined && row.aprovacao === 'reprovado') ? <span className="badge bg-danger" title={row.motivoReprovado !== undefined ? "Motivo: " + row.motivoReprovado : null} >Reprovado</span> : null}
                                                        </div>;
                                                    }
                                                },
                                                {
                                                    name: 'Evento',
                                                    selector: row => row.evento?.nome ?? "",
                                                    sortable: true,
                                                    cell: (row) => {
                                                        return row.evento ? row.evento.codigo + ' - ' + row.evento.nome : "";
                                                    },
                                                },
                                                {
                                                    name: 'Cliente',
                                                    selector: row => row.cliente?.nome ?? "",
                                                    sortable: true,
                                                    cell: (row) => {
                                                        var label = "";
                                                        if (row.cliente) {
                                                            label = row.cliente.codigo + ' - ' + row.cliente.nome;
                                                            if (row.cliente.enderecomunicipio) {
                                                                label += " - " + row.cliente.enderecomunicipio.nome + " - " + row.cliente.enderecomunicipio.uf;
                                                            }
                                                        }
                                                        return row.cliente ? label : "";
                                                    },
                                                },
                                                {
                                                    name: 'Data',
                                                    selector: row => row.data ?? "",
                                                    sortable: true,
                                                    cell: (row) => {
                                                        return row.data ? " " + moment(row.data).format("DD/MM/YYYY") : "";
                                                    },
                                                },
                                                {
                                                    name: 'Usuário',
                                                    selector: row => row.operador?.nome ?? "",
                                                    sortable: true,
                                                    cell: (row) => {
                                                        return row.operador ? row.operador.nome : "";
                                                    },
                                                },
                                                {
                                                    name: 'Pagamento',
                                                    selector: 'codigo',
                                                    cell: (row) => {
                                                        var valorTotalTitulos = 0;
                                                        row.titulo.forEach((titulo) => {
                                                            valorTotalTitulos += parseFloat(titulo.valorTotal);
                                                        });
                                                        return (<>
                                                            {row.titulo.length > 0 ?
                                                                <IconButton
                                                                    small={true}
                                                                    title="Pagamentos registrados"
                                                                    to={"/financeiroParcelaReceber?grupoTitulo=" + row.grupoTitulo}
                                                                    icon={<FaMoneyBill size={20} />}
                                                                    color={valorTotalTitulos < row.valorTotal ? "warning" : "success"} /> : null
                                                            }
                                                            <IconButton
                                                                small={true}
                                                                title="Registrar pagamento"
                                                                to={{
                                                                    pathname: "/cadastroParcelaReceber",
                                                                    state: {
                                                                        vendas: [row.id],
                                                                        acao: "insert"
                                                                    }
                                                                }}
                                                                icon={<FaPlus size={20} />}
                                                                color={"warning"} />
                                                        </>);
                                                    },
                                                    width: "140px",
                                                },
                                                {
                                                    name: 'Valor',
                                                    selector: row => row.valorTotal ?? "",
                                                    sortable: true,
                                                    right: true,
                                                    cell: (row) => {
                                                        var totalicms = row.vendaitem.reduce((total, item) => {
                                                            return total + parseFloat(item.icmsvalor) || 0;
                                                        }, 0);
                                                        var textoicms = totalicms > 0 ? <div>icms: {moeda(totalicms)}</div> : null;

                                                        var totalpis = row.vendaitem.reduce((total, item) => {
                                                            return total + parseFloat(item.pisvalor) || 0;
                                                        }, 0);
                                                        var textopis = totalpis > 0 ? <div>pis: {moeda(totalpis)}</div> : null;

                                                        var totalcofins = row.vendaitem.reduce((total, item) => {
                                                            return total + parseFloat(item.cofinsvalor) || 0;
                                                        }, 0);
                                                        var textocofins = totalcofins > 0 ? <div>cofins: {moeda(totalcofins)}</div> : null;

                                                        var totalipi = row.vendaitem.reduce((total, item) => {
                                                            return total + parseFloat(item.ipivalor) || 0;
                                                        }, 0);
                                                        var textoipi = totalipi > 0 ? <div>ipi: {moeda(totalipi)}</div> : null;

                                                        var totaliss = row.vendaitem.reduce((total, item) => {
                                                            return total + parseFloat(item.issvalor) || 0;
                                                        }, 0);
                                                        var textoiss = totaliss > 0 ? <div>iss: {moeda(totaliss)}</div> : null;

                                                        var totalirrf = row.vendaitem.reduce((total, item) => {
                                                            return total + parseFloat(item.irrfvalor) || 0;
                                                        }, 0);
                                                        var textoirrf = totalirrf > 0 ? <div>irrf: {moeda(totalirrf)}</div> : null;

                                                        var totalinss = row.vendaitem.reduce((total, item) => {
                                                            return total + parseFloat(item.inssvalor) || 0;
                                                        }, 0);
                                                        var textoinss = totalinss > 0 ? <div>inss: {moeda(totalinss)}</div> : null;

                                                        var totalcsll = row.vendaitem.reduce((total, item) => {
                                                            return total + parseFloat(item.csllvalor) || 0;
                                                        }, 0);
                                                        var textocsll = totalcsll > 0 ? <div>csll: {moeda(totalcsll)}</div> : null;
                                                        var totalImpostos = totalicms + totalpis + totalcofins + totalipi + totaliss + totalirrf + totalinss + totalcsll;
                                                        var valorTotal = row.valorTotal;
                                                        var totalLiquido = valorTotal - totalImpostos;
                                                        var textoValorLiquido = <div width="100%">líquido: {moeda(totalLiquido)}</div>;
                                                        var textoValorTotal = <div width="100%"><strong>total: {moeda(valorTotal)}</strong></div>;
                                                        return <div className="right">
                                                            {textoicms}
                                                            {textopis}
                                                            {textocofins}
                                                            {textoipi}
                                                            {textoiss}
                                                            {textoirrf}
                                                            {textoinss}
                                                            {textocsll}
                                                            {textoValorLiquido}
                                                            {textoValorTotal}
                                                        </div>;
                                                    },
                                                },
                                            ]}
                                            data={vendas}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </ErpTemplate>
    );
}
